module.exports = __webpack_public_path__ + "img/icon-31.362e2c68.svg";